import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

/**
 * 查询停车平台月租车列表
 *
 * 数据实时来自停车平台 2.9 接口（/getMonthlyRentList），后端已做字段归一化，
 * 返回字段与本系统 owner_car 对齐：carNum / ownerName / empMobile / roomName / num / startTime / endTime。
 *
 * @param {Object} params 查询参数
 * @param {Number} params.page 页码，从 1 开始
 * @param {Number} params.row 每页条数
 * @param {String} [params.plateNumber] 车牌号，可空
 * @returns {Promise} 返回 { records, total, data }
 */
export function listMonthlyRents(params) {
  return new Promise((resolve, reject) => {
    const communityId = getCommunityId()
    request({
      url: '/parking.listMonthlyRents',
      method: 'get',
      params: {
        ...params,
        communityId
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '查询平台月租车列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
